<template>
  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.5 9.5L28.5 28.5"
      stroke="#A3A3A3"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M28.5 9.5L9.5 28.5"
      stroke="#A3A3A3"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
